// extracted by mini-css-extract-plugin
export var buttonContainer = "index-module--buttonContainer--75Xl3";
export var container = "index-module--container---CKNE";
export var price = "index-module--price--GA97R";
export var priceTitle = "index-module--priceTitle--kJ38S";
export var pricingBox = "index-module--pricingBox--TIs3T";
export var promoText = "index-module--promoText--bNlKM";
export var title = "index-module--title--UQBNB";
export var tts = "index-module--tts--X0cnD";
export var value = "index-module--value--Diuc3";